import {
  CircularProgress,
  TableBody,
  TableCell,
  TableRow
} from '@mui/material';

const TableLoader = () => {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={12} align="center">
          <CircularProgress />
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

const TableNoDataPlaceholder = () => (
  <TableBody>
    <TableRow>
      <TableCell colSpan={12} align="center">
        <p style={{ textAlign: 'center' }}>
          <b>No data to display!</b>
        </p>
      </TableCell>
    </TableRow>
  </TableBody>
);

export { TableLoader, TableNoDataPlaceholder };
